


































































































































































import Vue from "vue";
import CirclePercent from "@/components/HostMonitor/CirclePercent.vue";
import Info from "@/components/HostMonitor/Info.vue";
import TagEdit from "@/components/HostMonitor/TagEdit.vue";
import StainEdit from "@/components/HostMonitor/StainEdit.vue";
import { Header } from "../components/MyTable.vue";
import { axios } from "../plugins";
import { mapState, mapGetters, mapActions } from "vuex";

const TableHeader: Header[] = [
  { title: "名称", width: 180 },
  { title: "状态", width: 100 },
  { title: "是否调度", width: 100 },
  { title: "系统版本", width: 200 },
  { title: "CPU" },
  { title: "内存" },
  { title: "容器组" },
  { title: "污点", width: 200 },
  { title: "标签", width: 200 }
];

const staintMap = {
  NoSchedule: "不允许调度",
  PreferNoSchedule: "尽量不调度",
  NoExecute: "驱逐已有容器组"
};
export default Vue.extend({
  name: "HostMonitor",
  components: { CirclePercent, Info, TagEdit, StainEdit },
  data() {
    return {
      TableHeader,
      disabled: false,
      selectColumns: [] as any[],
      hostCount: {},
      staintMap
    };
  },
  mounted() {
    this.getHosts();
    this.getHostCount();
  },
  computed: {
    ...mapState("HostMonitor", [
      "pageNum",
      "total",
      "hasNext",
      "pageSize",
      "loading"
    ]),
    ...mapGetters("HostMonitor", ["tableData"])
  },
  methods: {
    ...mapActions("HostMonitor", [
      "getData",
      "delete",
      "pageTurn",
      "clear",
      "filterSearch"
    ]),
    getHosts() {
      this.getData({ url: "/monitor/hosts" });
    },
    getHostCount() {
      axios.get("/monitor/hosts/count").then(res => {
        this.hostCount = res.data.data;
      });
    },
    showInfo(data: any) {
      (this.$refs.info as any).show(data);
    },
    isSchedulable(status: string) {
      return status !== "UNSCHEDULABLE";
    },
    isNormal(status: string) {
      return status !== "ABNORMAL";
    },
    columnSelect(data: any[]) {
      this.selectColumns = data;
    },

    // 选中行校验
    filterColumns(type = "tag") {
      // 未选中
      if (this.selectColumns.length === 0) {
        this.$message.error("请选择主机");
        return false;
      }
      // 选中一行
      if (this.selectColumns.length === 1) {
        return [this.selectColumns[0].name];
      }

      // 多行
      if (type === "tag") {
        // 标签一致判断
        const token = JSON.stringify(this.selectColumns[0].labels);
        const isTrue = this.selectColumns.every(item => {
          return JSON.stringify(item.labels) === token;
        });
        if (!isTrue) {
          this.$message.error("主机标签不一致，无法同时修改");
          return false;
        }
      } else if (type === "staint") {
        // 污点一致判断
        const token = JSON.stringify(this.selectColumns[0].taints);
        const isTrue = this.selectColumns.every(item => {
          return JSON.stringify(item.taints) === token;
        });
        if (!isTrue) {
          this.$message.error("主机污点不一致，无法同时修改");
          return false;
        }
      } else if (type === "status") {
        const token = this.isSchedulable(this.selectColumns[0].status);
        const isTrue = this.selectColumns.every(item => {
          return this.isSchedulable(item.status) === token;
        });
        if (!isTrue) {
          this.$message.error("主机调度不一致，无法同时修改");
          return false;
        }
      }
      // 返回 主机 name
      return this.selectColumns.map(item => item.name);
    },
    tagEdit() {
      const arrOrFalse = this.filterColumns("tag");
      if (arrOrFalse) {
        (this.$refs.tag as any).show(
          arrOrFalse,
          this.selectColumns[0].labels || {}
        );
      }
    },
    stainEdit() {
      const arrOrFalse = this.filterColumns("staint");
      if (arrOrFalse) {
        (this.$refs.stain as any).show(
          arrOrFalse,
          JSON.stringify(this.selectColumns[0].taints)
        );
      }
    },
    scheduleEdit(bool: boolean) {
      const arrOrFalse = this.filterColumns("status");
      if (arrOrFalse) {
        axios
          .post(`/hosts/schedule`, {
            hosts: arrOrFalse,
            action: bool ? "UNSCHEDULE" : "SCHEDULE"
          })
          .then(() => {
            this.$message.success("调度修改完成");
            this.filterSearch();
          });
      }
    },
    handleCommand(key: string) {
      //
      switch (key) {
        case "staint":
          this.stainEdit();
          break;
        case "tag":
          this.tagEdit();
          break;
        case "SCHEDULE":
          this.scheduleEdit(false);
          break;
        case "UNSCHEDULE":
          this.scheduleEdit(true);
          break;
      }
    },
    turnPage(page: number) {
      this.disabled = true;
      this.pageTurn({ page }).finally(() => {
        this.disabled = false;
      });
    }
  }
});
